import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import TimelineIcon from '@mui/icons-material/Timeline';
import FactCheckIcon from '@mui/icons-material/FactCheck';

export const BannerInfoAusenciaEmpleado = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA',
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
                    <EventBusyIcon sx={{ color: '#696CFF', fontSize: 32 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                        ¿Qué es la gestión de Ausencias?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                        Desde este módulo puedes administrar todas las ausencias de los empleados registrados en el sistema. Registra permisos, licencias médicas, vacaciones u otro tipo de inasistencias y gestiona su estado.
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <EditCalendarIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Registro de Solicitudes</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Crea y administra diferentes tipos de solicitudes de ausencia para cada uno de los empleados de la organización.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <TimelineIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Seguimiento e Historial</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Lleva un historial detallado de las ausencias por empleado, incluyendo fechas de inicio y fin.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <FactCheckIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Aprobaciones</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Gestiona el estado de cada solicitud, indicando si ha sido aprobada, rechazada o se mantiene pendiente.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
